import Vue from 'vue';
import Vuex from 'vuex';
import axios from "axios";
import jwt_decode from 'jwt-decode';
import config from './configuration.json'

Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        token: sessionStorage.getItem('token') || undefined,
        sessiontoken: sessionStorage.getItem('sessiontoken') || undefined,
        userinfo: (sessionStorage.getItem('sessiontoken') && sessionStorage.getItem('sessiontoken') !== "undefined") ? jwt_decode(sessionStorage.getItem('sessiontoken')) : '',
        loginProcessStep: sessionStorage.getItem('loginProcessStep') || undefined
    },
    getters: {
        firstname: state => {
            return state.userinfo.firstname;
        },
        lastname: state => {
            return state.userinfo.lastname;
        },
        loginname: state => {
            return state.userinfo.loginname;
        },
        email: state => {
            return state.userinfo.mail;
        },
        token: state => {
            return state.token;
        },
        sessiontoken: state => {
            return state.sessiontoken;
        },
        sessionExpire: state => {
            return new Date(state.userinfo.exp * 1000);
        },
        loginProcessStep: state => {
            return state.loginProcessStep;
        },
        scopes: state => {
            return state.userinfo.aud || [];
        },
        authenticated: state => {
            return (state.sessiontoken != undefined);
        },
        employeeid: state => {
            let employeeid = undefined;
            let scopes = state.userinfo.aud || [];
            
            for(let i=0; i< scopes.length; i++)
            {
                let scope = scopes[i];
                if (scope.startsWith("EID")) {
                    employeeid = parseInt(scope.substring(4));
                  }
            }
            
            return employeeid;
        },
        department: state => {
            let department = undefined;
            let scopes = state.userinfo.aud || [];
            
            for(let i=0; i < scopes.length; i++)
            {
                let scope = scopes[i];
                if (scope.startsWith("DEP_")) {
                    department = scope.substring(4);
                }
            }
            
            return department;
        }
    },
    mutations: {
        auth(state, tokens) {
            
            state.token = tokens.token;
            if(tokens.sessiontoken != undefined)
            {
                state.sessiontoken = tokens.sessiontoken;
                state.userinfo = jwt_decode(tokens.sessiontoken);
            }
        },
        logout(state) {
            state.token = undefined;
            state.profile = undefined;
            state.sessiontoken = undefined;
            state.userinfo = undefined;

            sessionStorage.removeItem('token');
            sessionStorage.removeItem('sessiontoken');
            sessionStorage.removeItem('profile');
        },
        setLoginProcessStep(state, processStep) {
            sessionStorage.setItem("loginProcessStep", processStep);
            state.loginProcessStep = processStep;
        }
    },
    actions: {
        async loginCallback({ commit }, tokens) {
            var temptoken = tokens;
            await commit("setLoginProcessStep", "callbackFromIdp");
            sessionStorage.setItem("token", temptoken.token);

            await commit("auth", temptoken);

            await axios.get(config.sessionUrl).then(function (response) {
                
                temptoken["sessiontoken"] = response.data.id_token;
                sessionStorage.setItem("sessiontoken", response.data.id_token);
                commit("auth", temptoken);
                //commit("setProfile", response.data);
            });

            /*await axios.get(config.profileDataUrl).then(function (response) {
                commit("setProfile", response.data);
            });*/
        },
        async loginWithSchottId({ commit }) {
            await commit("setLoginProcessStep", "redirectToIdp");
            let port =  (location.port != "" && location.port != 0) ? `:${location.port}` : "";
            window.location.href = `${config.loginUrl}&redirect_uri=https://${location.hostname}${port}/callback/&state=state`;
        },
        async logout({ commit }) {
            await commit("setLoginProcessStep", "logout");
            await commit("logout");
            window.location.href = config.logoutUrl;
        }
    }
})